module.exports = __webpack_public_path__ + "img/resume-parser.a2578aa5.svg";